<div class="top-header-wrapper">
    <img src="assets/icons/uat-marker.svg" alt="uat">
</div>
